// File Utilities - File handling helpers
export class FileUtils {
  
  // Format file size in human readable format
  static formatFileSize(bytes) {
    if (!bytes || bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  }
  
  // Get file icon based on extension
  static getFileIcon(filename) {
    const extension = filename.toLowerCase().split('.').pop();
    const iconMap = {
      pdf: '📄', 
      doc: '📝', docx: '📝', txt: '📝',
      xls: '📊', xlsx: '📊', csv: '📊',
      ppt: '📊', pptx: '📊',
      jpg: '🖼️', jpeg: '🖼️', png: '🖼️', gif: '🖼️',
      zip: '🗜️', rar: '🗜️',
      mp3: '🎵', mp4: '🎬',
      msg: '📧', eml: '📧'
    };
    return iconMap[extension] || '📎';
  }
  
  // Get file type category
  static getFileType(filename) {
    const extension = filename.toLowerCase().split('.').pop();
    const typeMap = {
      pdf: 'document',
      doc: 'document', docx: 'document', txt: 'document',
      xls: 'spreadsheet', xlsx: 'spreadsheet', csv: 'spreadsheet',
      ppt: 'presentation', pptx: 'presentation',
      jpg: 'image', jpeg: 'image', png: 'image', gif: 'image',
      zip: 'archive', rar: 'archive',
      mp3: 'audio', mp4: 'video',
      msg: 'email', eml: 'email'
    };
    return typeMap[extension] || 'file';
  }
}
